import isPepper from './isPepper';

const isPickupSchedulingAllowed = () => !isPepper();

export default isPickupSchedulingAllowed;
